import { Component } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { Observable } from 'rxjs';
import {
  SortingDirection,
  ListActions,
} from '../../../shared/constants/lists-constants';
import { ListsOverlayService } from '../../../lists/services/lists-overlay.service';
import { ManageVendorsModel } from './model/manage-vendors.model';
import { ExternalVendorService } from './services/external-vendor.service';
import { take } from 'rxjs/operators';
import { Crumb } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { PATHS } from '@shared/constants/paths';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manage-vendors',
  templateUrl: './manage-vendors.page.html',
  styleUrls: ['./manage-vendors.page.scss'],
})
export class ManageVendorsPage implements ViewWillEnter {
  readonly SortingDirection = SortingDirection;
  readonly ListActions = ListActions;
  vendorData$: Observable<ManageVendorsModel>;
  breadcrumbs: Crumb[];

  constructor(
    readonly platformService: PlatformService,
    public externalVendorService: ExternalVendorService,
    private listsOverlayService: ListsOverlayService,
    private panAppState: PanAppState,
    private translateService: TranslateService,
  ) {
    this.externalVendorService.resetSort();
    var homeCrumbUrl = this.platformService.isTouch.value
      ? '/touch/home'
      : '/desktop/home';
    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: homeCrumbUrl,
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.inventory',
        url: '/' + PATHS.INVENTORY,
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.manageVendors',
        url: '',
        active: true,
      },
    ];
  }

  ionViewWillEnter() {
    this.externalVendorService.resetSort();
    this.vendorData$ = this.externalVendorService.vendorsView$();
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.manageVendors),
    );
  }
  openDeleteModal() {
    this.externalVendorService.openOrCloseDeleteVendorModal(true);
  }

  handleDeleteDismiss = () => {
    this.externalVendorService.openOrCloseDeleteVendorModal(false);
  };

  handleDeleteSubmit = (vendorData: ManageVendorsModel) => {
    this.externalVendorService.openOrCloseDeleteVendorModal(false);
    this.externalVendorService.deleteExternalVendors(
      this.externalVendorService.getSelectedVendors(vendorData?.vendors),
    );
  };

  changeSort(column: string, vendorData: ManageVendorsModel) {
    this.externalVendorService.changeSort(column, vendorData);
  }

  async openMobileSort(vendorData: ManageVendorsModel) {
    this.listsOverlayService.openMobileSort(vendorData);
  }

  async openCreateNonUsfVendorModal(
    mode: string,
    vendorData: ManageVendorsModel,
  ) {
    this.listsOverlayService.openCreateEditNonUsfVendorModal(
      mode,
      vendorData,
      null,
    );
  }

  updateSelectedVendors(vendorId: string, currentValue: boolean) {
    this.externalVendorService.setSelectedVendors(vendorId, !currentValue);
  }
}
